// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bannerStyles } from "@pace/Overrides/Widgets/Category/CategoryDetailBanner";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.container = {
    css: css`
        margin-bottom: 32px;
        & .wrapper {
            background-color: ${color("common.ui11")};
            border-radius: 4px;
            ${({ hasImage }: any) => {
                if (hasImage) {
                    return css`
                        border-radius: 4px 0 0 4px;
                        ${xScreen("lte", "md")} {
                            border-radius: 0 0 4px 4px;
                        }
                    `;
                }
            }}

            & .image-section {
                order: 1;
            }
            & .content-section {
                order: 0;
            }

            ${xScreen("lte", "md")} {
                & .image-section {
                    order: 0;
                }
                & .content-section {
                    order: 1;
                }
            }
        }
    `,
};
